exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-04ebd0c3]{-o-object-fit:contain;object-fit:contain;overflow:hidden}.is-clipped[data-v-04ebd0c3]{overflow:clip}.light-border[data-v-04ebd0c3]{border:1px solid #bbb;border-radius:3px}.is-relative[data-v-04ebd0c3]{position:relative}.right-10px[data-v-04ebd0c3]{right:10px}", ""]);

// exports
